import * as types from './actionTypes';
import apiUtils from '../api/submissionApiUtils';
import { fieldToMerge, fieldToReset, pushToArray, removeFromArray } from '../api/actionUtils';
import { authenticatedFetch } from '@forwardfinancing/component-library';
import { SOURCES } from '../constants/global';
import { APPLICATION_FIELDS } from '../constants/serverFieldMappings';

export function setSubmissionFormInfo(section, name = "") {
  return {type: types.SET_SUBMISSION_INFO_FORM_SECTION_DATA, section, name};
}

export function confirmSubmissionInfo(info) {
  return {type: types.CONFIRM_SUBMISSION_INFO, info};
}

export function setSubmissionInfoLoading() {
  return {type: types.SUBMISSION_INFO_LOADING, isLoading: true};
}

export function clearSubmissionInfoLoading() {
  return {type: types.SUBMISSION_INFO_LOADING, isLoading: false};
}

export function removeOwner(index, data) {
  return dispatch => {
    const owner2Percentage = data.ownerInfo2_percent_ownership;
    for (let i = index; i < 2; i += 1) {
      const ownershipKey = `OWNERINFOPERCENT_${i + 1}`;
      dispatch(fieldToReset({model: "submission", key: APPLICATION_FIELDS[ownershipKey]}));
    }
    if (owner2Percentage && index === 0) {
      dispatch(fieldToMerge({model: "submission", key: APPLICATION_FIELDS["OWNERINFOPERCENT_1"], value: owner2Percentage}));
    }
    dispatch(removeFromArray({model: "submission", key: "owners", value: index}));
  };
}

export function addOwner() {
  return dispatch =>
    dispatch(pushToArray({
      model: "submission",
      key: "owners",
      value: {}
    }));
}

export function postNewSubmissionInfo(data) {
  const values = apiUtils.formatDataForSubmissionToLeads(data);
  const url = apiUtils.newSubmissionsURL();
  const errorMessage = "Failed to submit application";
  return dispatch => postInfo(url, values, errorMessage).then(dispatch);
}

export function postShortenedNewSubmissionInfo(data = {}) {
  const values = apiUtils.formatDataForShortenedSubmissionToLeads(data);
  const url = apiUtils.shortenedNewSubmissionsURL();
  const errorMessage = "Failed to submit application";
  const source = SOURCES['SHORT'];

  return dispatch => postInfo(url, values, errorMessage, source).then(dispatch);
}

export function postRenewalSubmissionInfo(data) {
  return dispatch => {
    const values = {renewal: data};
    const errorMessage = "Failed to submit renewal";

    return postInfo(
      apiUtils.underwritingRenewalSubmissionsURL(),
      values,
      errorMessage
    ).then(dispatch);
  };
}

export function postStipSubmissionInfo(data, files, uuid, fields) {
  const values = apiUtils.formatDataForSubmissionToStips(data, files, uuid, fields);
  const url = apiUtils.stipSubmissionsURL();
  const errorMessage = "Failed to submit stip";
  return dispatch => postInfo(url, values, errorMessage).then(dispatch);
}

function postInfo(url, values, errorMessage, source = SOURCES.STANDARD) {
  const body = JSON.stringify({...values, submission_source: source});
  return authenticatedFetch(url, {
    method: 'POST',
    body: body,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if(!response.ok){
      throw new Error(errorMessage);
    }

    return response;
  })
  .then(response => response.json())
  .then(json => confirmSubmissionInfo(json));
}